<template>
  <div>
    <b-input-group>
      <div class="div-dropdown-component">
        <SingleSelectInteger
          :value.sync="compProfileId"
          :value-property="'value'"
          :options="optionsProfile"
          :readonly="false"
        />
      </div>

      <b-input-group-append>
        <b-button v-b-modal.profileModal>
          <i class="tim-icons icon-simple-add" style="text-align: center" />
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <b-modal
      ref="profileModal"
      id="profileModal"
      title="Cadastro: Perfil"
      :ok-title="$t('geral.save')"
      :cancel-title="$t('geral.cancel')"
    >
      <div>
        <b-col>
          <CrudData
            ref="crudData"
            :model.sync="model"
            :modelstate="modelstate"
          />
          <p>teste</p>
        </b-col>
      </div>

      <template #modal-footer="{}">
        <div style="text-align: right; width: 100%">
          <b-button variant="green" @click="save" style="margin-left: 5px">
            {{ $t("geral.confirm") }}
          </b-button>

          <b-button class="ml-2" variant="danger" @click="cancelModal">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ProfileDropdownModal",
  props: {
    profileId: Number,
  },
  components: {
    CrudData: () => import("@/components_rms/System/Profile/CrudData.vue"),
    SingleSelectInteger: () =>
      import("@/components_rms/base/SingleSelectInteger.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "",
      },
      modelstate: [],
      model: null,
      optionsProfile: [{ value: null, text: "" }],
    };
  },
  computed: {
    compProfileId: {
      get: function () {
        return this.profileId;
      },
      set: function (value) {
        this.$emit("update:profileId", value);
      },
    },
  },
  created() {
    this.loadProfiles();
    this.createNew();
  },
  methods: {
    createNew() {
      this.model = {
        id: 0,
        displayName: "",
        administrator: false,
        accessCompany: false,
        accessUser: false,
        canImportUser: false,
        accessProfile: false,
        accessVehicles: false,
        accessTripPlan: false,
        checkelistTypingForm: false,
        checklistFormCreator: false,
        canEditForm: false,
        canDeleteForm: false,
        canReopenForm: false,
        checklistPendenciesView: false,
        canAccessJustOwnChecklist: false,
        trackingDeliveryman: false,
        trackingPlataformAccess: false,
        cargoKanbamAvaliable: false,
        cargoExpensesAvaliable: false,
        accessTypeOccurrence: false,
        accessTypeOccurrenceExpense: false,
        accessTypeVehicle: false,
        accessLoads: false,
        canActivateLoads: false,
        canDeleteLoads: false,
        bi: false,
        fuelSupply: false,
        fuelSupplyDashboard: false,
        revision: false,
        revisionDashboard: false,
      };
    },
    cancelModal() {
      this.$refs.profileModal.hide();
    },
    async loadProfiles() {
      try {
        const response = await this.$apiScheduler.get(
          "/profile/getCompanyProfiles"
        );
        response.data.forEach((p) => {
          this.optionsProfile.push({
            value: p.id,
            text: p.displayName,
          });
        });
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log("Load data error");
              } else {
                console.log(error.response.statusText);
              }
            } else {
              console.log(error.message);
            }
          }
        }
      }
    },
    async save() {
      try {
        this.modelstate = [];
        const response = await this.$apiScheduler.post(
          "/profile/create",
          this.model
        );
        if (response.data.success) {
          console.log(response);
          console.log(response.data.data.id);
          await this.loadProfiles();
          console.log(this.optionsProfile);
          this.compProfileId = parseInt(response.data.data.id);
          this.createNew();
          this.cancelModal();
        } else {
          this.modelstate = [];
          this.alert.error = response.data.title;
          this.showToastError();
          return;
        }
      } catch (error) {
        if (error.response.data == null) {
          this.modelstate = [];
          this.alert.error = error.response.title;
          this.showToastError();
          return;
        }
        if (error.response.data.errors != null) {
          this.modelstate = error.response.data.errors;
          this.alert.error = error.response.data.title;
          this.showToastError();
          return;
        }
        if (error.response.data.errorMessage) {
          this.modelstate = [];
          this.alert.error = error.response.data.errorMessage;
          this.showToastError();
          return;
        }
      }
    },
    showToastError(append = false) {
      this.$bvToast.toast(this.alert.error, {
        autoHideDelay: 5000,
        toaster: "b-toaster-top-full",
        variant: "danger",
        appendToast: append,
      });
    },
  },
};
</script>